import _once from "lodash/once";
import React from 'react';
import { LinkButton } from '../button/Button';
import { sendEvent } from '../../../../../../client/analytics/dataLayerService';
import { DATALAYER_EVENT } from '../../../../../../client/analytics/dataLayerConstants';
import { Platform, getPlatform } from '../../../../../util/getPlatform';
import { getUtmQueryParam, isPaidSocialSession } from '../../../../../util/utmHelper';
import { useCurrentLocale, useTranslator } from '../../../../../locales/useTranslator';
import * as googlePlayBadges from './googlePlayBadges';
import * as appStoreBadges from './appStoreBadges';
import './AppStoreButton.scss';
var GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.milanote.milanoteApp';
var APP_STORE_URL = 'https://itunes.apple.com/us/app/milanote/id1433852790?ls=1&mt=8';
var sendAppStoreLinkClickEvent = _once(function () {
  return sendEvent(DATALAYER_EVENT.APP_STORE_LINK_CLICK);
});
var AppleAppStoreButton = function AppleAppStoreButton() {
  var translate = useTranslator('marketing');
  var locale = useCurrentLocale();
  return /*#__PURE__*/React.createElement(LinkButton, {
    onClick: sendAppStoreLinkClickEvent,
    cta: true,
    href: APP_STORE_URL,
    className: "AppStoreButton"
  }, /*#__PURE__*/React.createElement("img", {
    src: appStoreBadges[locale] || appStoreBadges.en,
    alt: translate('callToAction.downloadOnTheAppStore')
  }));
};
var GooglePlayButton = function GooglePlayButton() {
  var translate = useTranslator('marketing');
  var locale = useCurrentLocale();
  var utmParam = getUtmQueryParam();
  var url = utmParam ? "".concat(GOOGLE_PLAY_URL, "&referrer=").concat(utmParam) : GOOGLE_PLAY_URL;
  return /*#__PURE__*/React.createElement(LinkButton, {
    onClick: sendAppStoreLinkClickEvent,
    cta: true,
    href: url,
    className: "AppStoreButton"
  }, /*#__PURE__*/React.createElement("img", {
    src: googlePlayBadges[locale] || googlePlayBadges.en,
    alt: translate('callToAction.getItOnGooglePlay')
  }));
};
var WebCTAButton = function WebCTAButton() {
  var translate = useTranslator('marketing');
  return /*#__PURE__*/React.createElement(LinkButton, {
    cta: true,
    href: "#signup-form"
  }, translate('callToAction.signUpForFree'));
};
export var AppStoreButton = function AppStoreButton() {
  if (isPaidSocialSession()) {
    return /*#__PURE__*/React.createElement(WebCTAButton, null);
  }
  var platform = getPlatform();
  switch (platform) {
    case Platform.ANDROID:
      return /*#__PURE__*/React.createElement(GooglePlayButton, null);
    case Platform.IOS:
      return /*#__PURE__*/React.createElement(AppleAppStoreButton, null);
    default:
      return /*#__PURE__*/React.createElement(WebCTAButton, null);
  }
};